import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { DashboardLocalStorageKey } from '../../enums/dashboard-local-storage-key.enum';
@Component({
	selector: 'vtr-menu-header',
	templateUrl: './menu-header.component.html',
	styleUrls: ['./menu-header.component.scss'],
})
export class MenuHeaderComponent implements OnInit {
	@Input() menuItems = [];
	public isGerman: Boolean = false;
	public lang: string = 'nl';
	constructor(public router: Router, private commonService: CommonService) {}

	ngOnInit() {
		this.getLanguage();
	}

	getActiveTab() {
		let activeTab = {};
		this.menuItems.forEach((d, i) => {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick($event, tab) {
		this.setActiveTab(tab);
	}

	setActiveTab(tab) {
		for (const item of this.menuItems) {
			item.active = false;
			if (item.id === tab.id) {
				item.active = true;
			}
		}
	}
	changeRoute(routeValue, outlets?, queryParams?: any) {
		this.router.navigate(['/' + routeValue, { outlets }], queryParams);
	}
	getLanguage() {
		const cachedDeviceInfo = this.commonService.getLocalStorageValue(
			DashboardLocalStorageKey.DeviceInfo,
			undefined
		);
		// In order to avoid affecting the overall design ,so only check out nl
		if (cachedDeviceInfo && cachedDeviceInfo.locale && cachedDeviceInfo.locale.length > 0) {
			const isLocaleSame = cachedDeviceInfo.locale === this.lang;
			this.isGerman = isLocaleSame;
		}
	}
}
